import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button, TextArea, Input, Grid, Text } from 'semantic-ui-react';

/**
 * A modal display the settings of shift on the given division.
 */

const styles = {
  Button: {
    marginTop: '10px',
    marginBottom: '5%',
    width: '100px',
    height: '40px',
  },
};

 class AlertModal extends React.Component {

  handleCloseModal = () => {
    this.props.onCloseModal();
  }

  render() {
    const {
      onCloseModal,
      alertText,
      openModal
    } = this.props;

    return (
      <Modal
        open={openModal}
        size={'small'}
        onClose={() => onCloseModal()}
        style={{width:'250px'}}
      >
      <Modal.Content style={{width: '90%'}}>
          <div align='center' style={{marginBottom:'15px', whiteSpace:'pre-wrap'}}>{alertText}</div>
          <div align='center'><Button onClick={() => onCloseModal()}>Close</Button></div>
      </Modal.Content>
      </Modal >
    );
  }
}

AlertModal.defaultProps = {
  onCloseModal: () => {},
  openModal: false,
  alertText: '',
}

AlertModal.propsType = {
  onCloseModal: PropTypes.func,
  openModal: PropTypes.bool,
  alertText: PropTypes.string,
}

export default React.memo(AlertModal);

